import axios from "axios";
import store from "@/store";
import i18n from "@/plugins/i18n";
import { ResponseModel } from "@/models/ResponseModel";

const path = process.env.VUE_APP_API_URL;
/** eKYC V2 endpoints; fallback to VUE_APP_API_URL if unset */
const pathV2 = process.env.VUE_APP_API_URL_V2 || path;
// const pathABA = process.env.VUE_APP_API_URL_ABA;

// const username = process.env.VUE_APP_USERID;
// const password = process.env.VUE_APP_PASSWORD;

/** 400: Bad Request */
export const CLIENT_ERROR_CODE = 400;

export const httpClient = axios.create({
  baseURL: path,
  json: true,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 6000000,
});
httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    store.dispatch("notifyStore/addNotify", {
      code: 1,
      message: i18n.global.t("Network Error"),
    });
    return Promise.resolve(error);
  }
);

export const httpClientV2 = axios.create({
  baseURL: pathV2,
  json: true,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 6000000,
});
httpClientV2.interceptors.response.use(
  (response) => response,
  (error) => {
    store.dispatch("notifyStore/addNotify", {
      code: 1,
      message: i18n.global.t("Network Error"),
    });
    return Promise.resolve(error);
  }
);

// export const httpClientABA = axios.create({
//     baseURL: pathABA,
//     json: true,
//     headers: {
//         'Content-Type': 'application/json'
//     },
//     timeout: 6000000
// })
// httpClientABA.interceptors.response.use(response => {
//     return response;
// }, error => {
//     store.dispatch("notifyStore/addNotify", { code: 1, message: i18n.global.t('Network Error') });
//     return Promise.resolve(error);
// });

class ApiClient {
  getInstance() {
    this.configHeader = {
      cancelToken: store.state.axiosStore.token,
    };
    return httpClient;
  }

  getInstanceV2() {
    this.configHeader = {
      cancelToken: store.state.axiosStore.token,
    };
    return httpClientV2;
  }

  // getInstanceStatus(username, password) {
  //     const basicToken = btoa(`${username}:${password}`);
  //     this.configHeader = {
  //         cancelToken: store.state.axiosStore.token,
  //         headers: {
  //             "X-Aba-Ts": "1646793463530", // hoặc dùng một hàm util như bạn đã làm
  //             "Content-Type": "application/json",
  //             "Authorization": `Basic c2FuZC1ib3g6UVVKQk9rRkNRVUJXTXk0d01USlBNakk9`
  //         }
  //     }
  //     return httpClientABA;
  // }

  /**
   * Get
   * @param url
   * @param config
   * @returns {Promise<{code: *, data: *, message: *}>}
   */
  async get(url, config = null) {
    this._config = { ...config };
    console.log("API Client Get URL:", path + url);
    await store.dispatch("axiosStore/setTokenConstructor", axios.CancelToken);
    try {
      const response = await this.getInstance().get(path + url, config);
      return ResponseModel.toJson(response.data);
    } catch (e) {
      return ResponseModel.toJson({
        code: CLIENT_ERROR_CODE,
        message: e.toString(),
        data: null,
      });
    }
  }

  /**
   * Post
   * @param url
   * @param data
   * @param config
   * @returns {Promise<{code: *, data: *, message: *}>}
   */
  async post(url, data, config = null) {
    this._config = { ...config };
    console.log("===============================");
    console.log("API Client Post URL:", path + url);
    console.log("API Client Post Data:", data);
    const response = await this.getInstance().post(
      path + url,
      data,
      this.configHeader
    );
    if (response && response.data) return ResponseModel.toJson(response.data);
    return null;
  }

  async postV2(url, data, config = null) {
    this._config = { ...config };
    console.log("API Client PostV2 URL:", pathV2 + url);
    console.log("API Client PostV2 Data:", data);
    const response = await this.getInstanceV2().post(
      pathV2 + url,
      data,
      this.configHeader
    );
    if (response && response.data) return ResponseModel.toJson(response.data);
    return null;
  }

  // async postStatus(url, data, config = null) {
  //     this._config = { ...config };
  //     const response = await this.getInstanceStatus(username, password).post(pathABA + url, data, this.configHeader);
  //     if (response && response.data) {
  //         return ResponseModel.toJson(response.data);
  //     }
  //     return null;
  // }
}

export const apiClient = new ApiClient();
